// extracted by mini-css-extract-plugin
export default {"containerWrapper":"MessagesContainer__containerWrapper___N97Bo","container":"MessagesContainer__container___qqala","spacer":"MessagesContainer__spacer___kbbbT"};